"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.earlyProcessingCloses = void 0;
exports.earlyProcessingCloses = {
    '2017-07-03': -150,
    '2018-07-03': -150,
    '2019-07-03': -150,
    '2023-07-03': -150,
    '2017-11-24': -150,
    '2018-11-22': -150,
    '2019-11-29': -150,
    '2020-11-27': -150,
    '2021-11-26': -150,
    '2022-11-25': -150,
    '2023-11-24': -150,
    '2018-12-24': -150,
    '2019-12-24': -150,
    '2020-12-24': -150,
};
//# sourceMappingURL=earlyProcessingCloses.js.map